module.exports = __webpack_public_path__ + "img/2.a9d98e1b.jpg";